module.exports = __webpack_public_path__ + "img/arrow_purple_new.1137cb2e.svg";